import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetchCompanyHistory } from '../../actions/companyActions'

const useFetchingCompanyHistory = (id, page, pageSize) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchCompanyHistory(id, true, page, pageSize))
  }, [dispatch, id])
}

export default useFetchingCompanyHistory
